import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';

export const StyledLinkText = styled('a')`
    ${({ theme }: { theme: Theme }) => theme.typography.text_12_lh_18};
    ${({ theme }: { theme: Theme }) => `
        color: ${theme.palette.common.blue};
        padding-top: ${theme.tggSpacing(rem(1.5), 3.75)};
        text-decoration: none;
        text-transform: lowercase;
	`}
`;

export const StyledList = styled('ul')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        padding: ${theme.tggSpacing(0, 0)};
        margin: ${theme.tggSpacing(0, 0)};
        list-style: none;
	`}
`;

export const StyledListItem = styled('li')`
    ${({ theme }: { theme: Theme }) => `
        padding-top: ${theme.tggSpacing(rem(1.5), 3.75)};
	`}
`;
